<template>
    <div class="mobile-menu-button-container">
        <button class="hamburger hamburger--spin-r" type="button" @click="toggle" :class="{ 'is-active': $root.menuOpen }">
            <span class="hamburger-box">
                <span class="hamburger-inner"></span>
            </span>
        </button>
    </div>
</template>

<script>

export default {

    methods: {

        toggle(e) {
            this.$root.menuOpen = !this.$root.menuOpen;
            if (this.$root.menuOpen) this.$root.orderSummaryOpen = false;
        }
    }
}

</script>


// WEBPACK FOOTER //
// resources/js/components/sales/MenuButton.vue